import { React} from "react";
export default function header(){
    return(
        <>
        <header>
  <div class="header-container">
    <div class="header-title">Information regarding exam</div>
    <div class="header-info">
    <div class="header-item"><span class="header-heading">Title:</span> Exam on Database Management Systems</div>
<div class="header-item"><span class="header-heading">Date:</span> 25th April 2023</div>
<div class="header-item"><span class="header-heading">Professor:</span> Dr. John Smith</div>
<div class="header-item"><span class="header-heading">College:</span> College of Engineering</div>
<div class="header-item"><span class="header-heading">Department:</span> Computer Science & Engineering</div>
<div class="header-item"><span class="header-heading">Semester:</span> 6th</div>
<div class="header-item"><span class="header-heading">Group:</span> A</div>

    </div>
  </div>
</header>
        </>
    )
}